import React, { useEffect, useState } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { RiSettings4Line } from "react-icons/ri";
import { useAPI } from "../Context/MyContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Timer } from "lucide-react";

const Dashboard = () => {
  const { getPhoneAll, connectWhatsAppWithFacebook, registerPhone, disconnectPhone, fetchTrailStatus } = useAPI();
  const [whatsappProfiles, setWhatsappProfiles] = useState([]);
  const [waData, setWaData] = useState(null);
  const [code, setCode] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const [showPinModal, setShowPinModal] = useState(false);
  const [showDisconnectModal, setShowDisconnectModal] = useState(false);
  const [loadingProfiles, setLoadingProfiles] = useState(true); // ← ADDED: skeleton state

  const [selectedProfile, setSelectedProfile] = useState(null);
  const [pin, setPin] = useState("");

  const [isRegistering, setIsRegistering] = useState(false);
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [trialInfo, setTrialInfo] = useState({
    isActive: false,
    remainingDays: 0,
    expiresAt: null,
    message: "",
  });

  const [trialLoading, setTrialLoading] = useState(false);
  const [trialError, setTrialError] = useState("");
  const [countdown, setCountdown] = useState("");


  useEffect(() => {
    let interval;

    if (trialInfo.isActive && trialInfo.expiresAt) {
      interval = setInterval(() => {
        const now = new Date().getTime();
        const expiry = new Date(trialInfo.expiresAt).getTime();
        const distance = expiry - now;

        if (distance <= 0) {
          setCountdown("Trial expired");
          clearInterval(interval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setCountdown(
          `${days}d ${hours}h ${minutes}m ${seconds}s`
        );
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [trialInfo]);


  // const [loadingManageId, setLoadingManageId] = useState(null);
  const navigate = useNavigate();

  const fetchTrailInfo = async () => {
    try {
      setTrialLoading(true);
      setTrialError("");

      const data = await fetchTrailStatus();
      console.log("Fetched trial status:", data);

      setTrialInfo({
        isActive: data.isActive || false,
        remainingDays: data.remainingDays || 0,
        expiresAt: data.expiresAt || null,
        message: data.message || "",
      });

    } catch (err) {
      console.error("Failed to fetch trial status:", err);

      setTrialError(
        err?.response?.data?.message || "Failed to fetch trial status"
      );

      setTrialInfo({
        isActive: false,
        remainingDays: 0,
        expiresAt: null,
        message: "",
      });

    } finally {
      setTrialLoading(false);
    }
  };

  const fetchPhones = async () => {
    try {
      const res = await getPhoneAll();
      // console.log("Fetched WhatsApp data:", res);
      setWhatsappProfiles(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch phones:", err);
    } finally {
      setLoadingProfiles(false); // ← ADDED: hide skeleton after fetch
    }
  };
  useEffect(() => {


    fetchPhones();
    fetchTrailInfo(); // Fetch trial status on component mount
  }, []);

  useEffect(() => {
    // Listen for Meta's message after embedded signup finishes
    const handleMessage = async (event) => {
      if (event.origin !== "https://www.facebook.com") return;

      try {
        const data = JSON.parse(event.data);

        if (data.type === "WA_EMBEDDED_SIGNUP") {
          // console.log("Signup completed:", data);
          setWaData(data.data);
        }
      } catch (err) {
        console.error("Error parsing message:", err);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);


  useEffect(() => {
    if (!waData || !code) return;

    const payload = {
      code,
      whatsapp_business_id: waData.waba_id,
      phone_number_id: waData.phone_number_id,
    };

    const connectAndRefresh = async () => {
      try {
        const result = await connectWhatsAppWithFacebook(payload);

        if (result?.success) {
          await fetchPhones(); // ✅ REFRESH HERE
        }
      } catch (err) {
        console.error("Failed to connect WhatsApp:", err);
      }
    };

    connectAndRefresh();
  }, [waData, code]);


  const fbLoginCallback = (response) => {
    if (response.authResponse) {
      const code = response;
      // console.log("first code:", code);
      setCode(response.authResponse.code);
    } else {
      console.error(" No authResponse from Facebook");
    }
  };

  const launchWhatsAppSignup = () => {
    window.FB.login(fbLoginCallback, {
      config_id: '1113616143529330',
      // config_id: '1305579104198118',
      response_type: 'code',
      override_default_response_type: true,
      extras: { version: 'v3' },
    });
  };


  const handleRegisterClick = (profile) => {
    setSelectedProfile(profile);
    setPin("");
    setShowPinModal(true);
  };



  const submitPinRegistration = async () => {
    if (!/^\d{6}$/.test(pin)) {
      toast.error("PIN must be exactly 6 digits");
      return;
    }

    setIsRegistering(true);
    setLoadingId(selectedProfile.phone_number_id);

    try {
      const res = await registerPhone({
        phone_number_id: selectedProfile.phone_number_id,
        pin,
      });

      if (res?.success) {
        toast.success("Phone registered successfully!");
        await fetchPhones();
        setShowPinModal(false);
      } else {
        // toast.error(res?.message || "Failed to register phone");
        console.log("failed in register", res)
        // toast.error(
        //   `${res?.message || "Failed to register phone"}\n${res?.details || ""}`

        // );

        toast.error(
          <div style={{ lineHeight: 1.4 }}>
            <div style={{ fontWeight: 600 }}>
              {res?.message || "Unable to register phone number"}
            </div>
            {res?.details && (
              <div style={{ fontSize: "0.85rem", opacity: 0.85, marginTop: 4 }}>
                Reason: {res.details}
              </div>
            )}
          </div>
        );

      }
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setIsRegistering(false);
      setLoadingId(null);
    }
  };



  const handleDisconnectClick = (profile) => {
    setSelectedProfile(profile);
    setShowDisconnectModal(true);
  };


  const confirmDisconnect = async () => {
    if (!selectedProfile) return;

    setIsDisconnecting(true);
    setLoadingId(selectedProfile.phone_number_id);

    try {
      const res = await disconnectPhone(selectedProfile.phone_number_id);

      if (res?.success) {
        toast.success("WhatsApp disconnected successfully");
        await fetchPhones();
        setShowDisconnectModal(false);
      } else {
        toast.error(res?.message || "Failed to disconnect");
      }
    } catch (err) {
      // console.error("Disconnect error:", err);
      toast.error("Failed to disconnect WhatsApp. Please try again later.");
    } finally {
      setIsDisconnecting(false);
      setLoadingId(null);
    }
  };

  const handleManageClick = (profile) => {
    navigate(
      `/dashboard/manage-phone/${profile.phone_number_id}/overview`
    );
  };

  // ── ADDED: skeleton card that mirrors the real card layout exactly ──
  const SkeletonCard = () => (
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm p-4 sm:p-6 lg:p-8">
      {/* header row: title + manage button */}
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <div className="h-4 w-48 bg-gray-200 animate-pulse rounded-full" />
        <div className="h-8 w-20 bg-gray-200 animate-pulse rounded" />
      </div>
      {/* inner profile box */}
      <div className="border rounded-xl p-4 sm:p-6 bg-gray-50 space-y-3">
        {/* avatar + name */}
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
          <div className="space-y-2 flex-1">
            <div className="h-4 w-36 bg-gray-200 animate-pulse rounded-full" />
            <div className="h-3 w-24 bg-gray-200 animate-pulse rounded-full" />
          </div>
        </div>
        {/* divider */}
        <div className="border-t border-gray-200" />
        {/* info rows */}
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="h-3 w-36 bg-gray-200 animate-pulse rounded-full flex-shrink-0" />
            <div className="h-3 w-40 bg-gray-200 animate-pulse rounded-full" />
          </div>
        ))}
        {/* button */}
        <div className="flex justify-end mt-2">
          <div className="h-8 w-24 bg-gray-200 animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
  // ───────────────────────────────────────────────────────────────────

  return (
    <div className="px-4 py-6 sm:px-6 md:px-8 lg:px-12 xl:px-16 bg-gray-50 min-h-screen">

      {/* Trail details. Remaining days */}


      {trialInfo.isActive && (
        <div className="flex justify-center mb-4">
          <div className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-blue-500 via-purple-400 to-pink-400 shadow-lg">
            {trialLoading ? (
              <p className="text-sm font-medium text-white text-center">
                Checking trial status...
              </p>
            ) : trialError ? (
              <p className="text-sm font-medium text-white text-center">
                {trialError}
              </p>
            ) : (
              <>
                <Timer className="w-5 h-5 text-white" />
                <p className="text-sm md:text-base font-semibold text-white text-center">
                  {countdown} remaining on your trial
                </p>
              </>
            )}
          </div>
        </div>
      )}

      {/* Main Section */}

      <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 md:p-10 max-w-5xl mx-auto">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">
            Connect WhatsApp Business{" "}
            <span className="text-green-600 font-semibold">(Recommended)</span>
          </h2>
          <p className="mt-2 text-xs sm:text-sm text-gray-500">
            One Click Business Integration
          </p>
        </div>

        <div className="mt-6 sm:mt-8 text-center">
          <button onClick={launchWhatsAppSignup} className="bg-green-500 hover:bg-green-600 text-white flex items-center gap-2 mx-auto py-2.5 sm:py-3 px-6 sm:px-8 rounded-full text-base sm:text-lg font-semibold shadow-md transition duration-300">
            <FaWhatsapp size={20} className="sm:w-6 sm:h-6" />
            Connect WhatsApp
          </button>
        </div>

        <ul className="mt-6 sm:mt-8 text-xs sm:text-sm text-gray-700 list-disc pl-5 sm:pl-6 space-y-2 sm:space-y-3">
          <li>
            The seamless integration will open in a pop-up. Make sure your
            browser is not blocking pop-ups.
          </li>
          <li>
            You will be asked to provide a phone number for WhatsApp Business
            integration. We strongly recommend using a new phone number.
          </li>
          <li>
            If you already have a WhatsApp account associated with that number,
            back up your WhatsApp data and then delete that account.
          </li>
        </ul>
      </div>

      {/* Bottom Section - Render Multiple Business Info Cards */}
      <div className="mt-8 sm:mt-12 max-w-7xl mx-auto grid gap-4 sm:gap-6 grid-cols-1 xl:grid-cols-2">

        {/* ── skeleton while fetching, real cards after ── */}
        {loadingProfiles ? (
          Array.from({ length: 2 }).map((_, i) => <SkeletonCard key={i} />)
        ) : (
          whatsappProfiles.map((profile, index) => (
            <div key={index} className="bg-white rounded-xl sm:rounded-2xl shadow-sm p-4 sm:p-6 lg:p-8">
              {/* Header with Manage Button */}
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <h3 className="font-semibold text-base sm:text-lg text-gray-800">
                  WhatsApp Business Account
                </h3>
                <button
                  onClick={() => handleManageClick(profile)}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-xs sm:text-sm font-semibold py-1.5 px-3 sm:px-4 mr-2 rounded shadow flex items-center gap-1"
                >
                  <RiSettings4Line size={14} className="sm:w-4 sm:h-4" />
                  Manage
                </button>
              </div>

              {/* Buttons */}
              {/* <div className="flex gap-2 mb-6">

              <button className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-semibold py-1.5 px-4 rounded shadow flex items-center gap-1">
                <RiSettings4Line size={16} />
                Manage
              </button>
            </div> */}
              {/* <div className="flex gap-2 mb-6">

              <button
                // onClick={() => navigate(`/dashboard/manage-contacts/${profile.phone_number_id}`)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-semibold py-1.5 px-4 rounded shadow flex items-center gap-1"
              >
                <RiSettings4Line size={16} />
                Manage
              </button>
            </div> */}

              {/* <div className="flex gap-2 mb-4 sm:mb-6">

              <button
                onClick={() => handleManageClick(profile)}
                // disabled={loadingManageId === profile.phone_number_id}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-semibold py-1.5 px-4 rounded shadow flex items-center gap-1"
              >
                <RiSettings4Line size={16} />
                {loadingManageId === profile.phone_number_id ? "Loading..." : "Manage"}
              </button>

              <button
                onClick={() => handleManageClick(profile)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-xs sm:text-sm font-semibold py-1.5 px-3 sm:px-4 rounded shadow flex items-center gap-1"
              >
                <RiSettings4Line size={14} className="sm:w-4 sm:h-4" />
                Manage
              </button>
            </div> */}

              {/* Profile Info */}
              <div className="border rounded-xl p-4 sm:p-6 bg-gray-50 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-green-100 flex items-center justify-center flex-shrink-0">
                    {profile.profile_picture_url ? (
                      <img
                        src={profile.profile_picture_url}
                        alt={profile.verified_name}
                        className="w-full h-full object-cover"
                        referrerPolicy="no-referrer"
                      />
                    ) : (
                      <FaWhatsapp className="text-green-600 text-lg sm:text-xl" />
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-base sm:text-lg text-gray-800 break-words">
                      {profile.verified_name || "Unnamed Business"}
                    </div>
                    <div className="text-xs sm:text-sm text-gray-500">Profile Settings</div>
                  </div>
                </div>

                {/* subtle divider between avatar and info rows */}
                <div className="border-t border-gray-200" />

                <div className="space-y-2.5 text-xs sm:text-sm">
                  <div className="flex items-start gap-2 flex-wrap">
                    <span className="text-gray-400 flex-shrink-0 w-36 flex gap-3  ">
                      {/* <span className="sr-only">Phone Number</span> */}
                      <FaPhoneAlt className="flex-shrink-0 mt-1" />
                      Number
                    </span>
                    <span className="font-medium text-gray-800 break-all">{profile.display_phone_number}</span>
                  </div>
                  <div className="flex items-start gap-2 flex-wrap">
                    <span className="text-gray-400 flex-shrink-0 w-36">Phone Number ID</span>
                    <span className="font-medium text-gray-800 break-all">{profile.phone_number_id}</span>
                  </div>
                  <div className="flex items-start gap-2 flex-wrap">
                    <span className="text-gray-400 flex-shrink-0 w-36">Business Acct ID</span>
                    <span className="font-medium text-gray-800 break-all">{profile.waba_id}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-400 flex-shrink-0 w-36">Status</span>
                    {/* was plain text — now a small colour pill */}
                    {(() => {
                      const s = (profile.status || "").toUpperCase();
                      const cls =
                        s === "CONNECTED" ? "bg-green-50 text-green-700 border-green-200" :
                          s === "PENDING" ? "bg-amber-50 text-amber-700 border-amber-200" :
                            s === "FLAGGED" ? "bg-orange-50 text-orange-700 border-orange-200" :
                              s === "RATE_LIMITED" ? "bg-red-50 text-red-700 border-red-200" :
                                "bg-gray-100 text-gray-600 border-gray-200";
                      const dot =
                        s === "CONNECTED" ? "bg-green-500 animate-pulse" :
                          s === "PENDING" ? "bg-amber-400" :
                            s === "FLAGGED" ? "bg-orange-500" :
                              s === "RATE_LIMITED" ? "bg-red-500" :
                                "bg-gray-400";
                      return (
                        <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>
                          <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dot}`} />
                          {profile.status}
                        </span>
                      );
                    })()}
                  </div>
                </div>

                <div className="flex justify-end gap-2 sm:gap-4 mt-6 flex-wrap">
                  {profile.status !== "CONNECTED" && (

                    <button
                      disabled={loadingId === profile.phone_number_id}
                      onClick={() => handleRegisterClick(profile)}
                      className="bg-green-100 hover:bg-green-200 text-green-700 text-xs sm:text-sm font-semibold py-1.5 px-3 sm:px-4 rounded shadow"
                    >
                      Register
                    </button>

                  )}
                  {
                    profile.status == "CONNECTED" && (
                      <button
                        disabled={loadingId === profile.phone_number_id}
                        onClick={() => handleDisconnectClick(profile)}
                        className="bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-gray-800 text-xs sm:text-sm py-1.5 sm:py-2 px-4 sm:px-6 rounded-md  font-semibold shadow"
                      >
                        Disconnect
                      </button>
                    )
                  }


                </div>

              </div>
            </div>
          ))
        )}
      </div>

      {showPinModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg">
            <h3 className="text-lg font-semibold mb-2">
              Register WhatsApp Number
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              Enter your 6-digit WhatsApp registration PIN
            </p>

            <input
              type="password"
              maxLength={6}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
              className="w-full border rounded-md px-4 py-2 text-center tracking-widest text-lg"
              placeholder="••••••"
            />

            <div className="flex justify-end gap-3 mt-6">
              <button
                disabled={isRegistering}
                onClick={() => setShowPinModal(false)}
                className="px-4 py-2 text-sm bg-gray-100 rounded-md disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                onClick={submitPinRegistration}
                disabled={isRegistering}
                className="bg-green-100 hover:bg-green-200 disabled:opacity-60 disabled:cursor-not-allowed text-green-700 text-sm font-semibold py-1.5 px-4 rounded shadow flex items-center gap-2"
              >
                {isRegistering && (
                  <span className="w-4 h-4 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></span>
                )}
                {isRegistering ? "Registering..." : "Register"}
              </button>

            </div>
          </div>
        </div>
      )}

      {showDisconnectModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg">
            <h3 className="text-lg font-semibold mb-2 text-red-600">
              Disconnect WhatsApp
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to disconnect this WhatsApp number?
              <br />
              <span className="font-medium">
                {selectedProfile?.display_phone_number}
              </span>
            </p>

            <div className="flex justify-end gap-3">

              <button
                disabled={isDisconnecting}
                onClick={() => setShowDisconnectModal(false)}
                className="px-4 py-2 text-sm bg-gray-100 rounded-md disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                onClick={confirmDisconnect}
                disabled={isDisconnecting}
                className="px-4 py-2 text-sm bg-red-600 text-white rounded-md disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isDisconnecting && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {isDisconnecting ? "Disconnecting..." : "Disconnect"}
              </button>

            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default Dashboard;